import { FgStatusEnum, GlobalStatus, InventoryTypeEnum, OperationTypeEnum, PlantsEnum, ProductionProcessTypeEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { ProductionLog } from "./production-log.entity";

@Entity("production_inventory")
export class ProductionInventory {

    @PrimaryGeneratedColumn("increment", { name: 'prod_inv_id' })
    productionInventoryId: number;

    @Column("varchar", {
        nullable: true,
        name: "lot_number",
        length: 255
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "sub_lot_number",
        length: 100
    })
    subLotNumber: string;


    @Column("int", {
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId: number;

    @Column("int", {
        nullable: true,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;

    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'operation'
    })
    operation: OperationTypeEnum;

    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'category'
    })
    operationCategory: OperationTypeEnum;


    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'next_operation'
    })
    nextOperation: OperationTypeEnum;

    // @Column({
    //     type: "decimal", precision: 10, scale: 3,
    //     nullable: false,
    //     default: 0,
    //     name: "original_quantity"
    // })
    // originalQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "physical_quantity"
    })
    physicalQuantity: number; // originalQuantity

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "issued_quantity"
    })
    issuedQuantity: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "intransit_quantity"
    })
    intransitQuantity: number;



    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "wip_quantity"
    })
    wipQuantity: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "wastage_quantity"
    })
    wastageQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "rejected_quantity"
    })
    rejectedQuantity: number; // for re assigning
    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "assigned_rejection"
    })
    assignedRejection: number; // for re assigning


    @Column("int", {
        nullable: true,
        name: "boxes",
        default:0
    })
    boxes: number;


    @Column("int", {
        nullable: true,
        name: "op_boxes",
        default:0
    })
    opBoxes: number;

    @Column("int", {
        nullable: true,
        name: "transfered_boxes",
        default:0
    })
    transferedBoxes: number;

    @Column("int", {
        nullable: true,
        name: "converted_boxes",
        default:0
    })
    convertedBoxes: number;

    @Column({
        type: 'enum',
        enum: GlobalStatus,
        nullable: true,
        default: GlobalStatus.NO,
        name: 'weighment_req'
    })
    weighmentReq: GlobalStatus;


    @Column('varchar', {
        nullable: true,
        default: 0,
        name: "input_grade"
    })
    inputGrade: string;

    @Column('varchar', {
        nullable: true,
        default: 0,
        name: "output_grade"
    })
    outputGrade: string;

    @Column('int', {
        nullable: true,
        default: 0,
        name: "plant_id"
    })
    plantId: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "stock_transfer_qty"
    })
    stockTransferQty: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "conversion_quantity"
    })
    conversionQuantity: number;


    @Column({
        type: 'enum',
        enum: FgStatusEnum,
        nullable: true,
        default: FgStatusEnum.OPEN,
        name: 'status'
    })
    status: FgStatusEnum;


    @Column({
        type: 'enum',
        enum: InventoryTypeEnum,
        nullable: true,
        default: InventoryTypeEnum.Production,
        name: 'inventory_type'
    })
    inventoryType: InventoryTypeEnum;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'sub_plant_id'
    })
    subPlantId: number;

    // @Column({
    //     type: 'enum',
    //     enum: SubPlantCodesEnum,
    //     nullable: true,
    //     default: SubPlantCodesEnum.KDM,
    //     name: 'sub_plant_id'
    // })
    // subPlantId: SubPlantCodesEnum;
    
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    // @Column("varchar",{
    //     nullable:false,
    //     name:"plant_lot_number"
    // })
    // plantLotNumber:string

    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'prev_operation'
    })
    prevOperation: OperationTypeEnum;

    @Column("varchar",{
        nullable:true,
        name:"product",
        length:100
    })
    product:string

    @Column('int',{
        name:'year'
    })
    year:number

    @Column('enum',{
        name:'process_type',
        nullable:false,
        default:ProductionProcessTypeEnum.FRESHPRODUCITON,
        enum:ProductionProcessTypeEnum
    })
    processType : ProductionProcessTypeEnum

    @Column('boolean',{
        name:'is_rrp',
        default:false
    })
    isRRP : boolean

    
    // @OneToMany(type => ProductionLog, log => log.productionInventoryInfo, {cascade: true})
    // productionLog: ProductionLog[];
}